// A webes (ügyfélportálos) rendelési tételek rendelésszám szerinti csoportosítása (2026-11-03).
// Egy rendelésszám = egy rendelés = egy számla, ha a tételek kért napja és számlakiállítója egyezik.
// A sorok objektumai változatlanok maradnak (a v-model rajtuk dolgozik), csak csoportokba kerülnek.

export const itemTotal = (v) => (String(v.tszam) === '2' ? 6 : 1) * (Number(v.db) || 0) * (Number(v.ar) || 0)

export default function groupOrders(list) {
	let groups = []
	let byKey = {}

	for (let v of list || []) {
		// a régi (2024 előtti) portálos sorokon nincs rendelésszám: azok önálló tételek
		let key = v.rendelesszam ? `${v.uszam}|${v.rendelesszam}` : `id|${v.id}`
		let g = byKey[key]
		if (!g) {
			g = byKey[key] = { key, rendelesszam: v.rendelesszam || '', nev: v.nev, uszam: v.uszam, regio: v.regio, items: [] }
			groups.push(g)
		}
		g.items.push(v)
	}

	for (let g of groups) {
		let datums = g.items.map(x => String(x.datum || '')).filter(Boolean).sort()
		g.datum = datums[0] || ''
		// az ügyfél később, a portálon hozzáadott tételei (a beküldésnél későbbi időponttal)
		g.added = g.items.filter(x => x.datum && String(x.datum) > g.datum).length
	}

	return groups
}

// Eltérések egy rendelésen belül: eltérő számlakiállítónál külön számla készül,
// eltérő kért napnál a tételek külön szállításra kerülnek
export function groupWarnings(g) {
	let w = []
	if (new Set(g.items.map(x => String(x.kidatum))).size > 1) w.push('eltérő kért nap')
	if (new Set(g.items.map(x => String(x.szla_szolg))).size > 1) w.push('eltérő számlakiállító (külön számla)')
	return w
}



// WEBPACK FOOTER //
// ./src/components/webOrders/groupOrders.js